import { HttpService } from "./http.service";

export class InvestorStatementService extends HttpService {
  async getInvestorStatementData(
    investorStatementData: Record<string, any>
  ): Promise<{ investor_accounts: any }> {
    return await this.fetchJson<{
      investor_accounts: any;
    }>(
      "/investment-portal/investor-statement-data",
      "POST",
      investorStatementData
    );
  }
  async getActivationDate(investmentData: Record<string, any>): Promise<{
    investor_activation_date: any;
    investor_account_friendly_id: any;
  }> {
    return await this.fetchJson<{
      investor_activation_date: any;
      investor_account_friendly_id: any;
    }>("/investment-portal/grab-activation-date", "POST", investmentData);
  }
  async downloadAnnualReport(year: Record<string, any>): Promise<{
    report_data: any;
  }> {
    return await this.fetchJson<{
      report_data: any;
    }>("/investment-portal/download-annual-statements", "POST", year);
  }
  async downloadMonthlyReport(monthlyReportData: Record<string, any>): Promise<{
    report_data: any;
  }> {
    return await this.fetchJson<{
      report_data: any;
    }>(
      "/investment-portal/download-monthly-statements",
      "POST",
      monthlyReportData
    );
  }
}
